import apiClient from './apiClient';

export class CategoryKeywordsService {
  /**
   * @param {number} parentID - Acumatica category ID; 0 for the root categories.
   * @returns {Promise<Array<{ categoryID: number, parentID: number, description: string, hasChildren: boolean,
   *   catCodeString: string, isMarketScoutCatCode: boolean, wordsToInclude: string, wordsToExclude: string }>>}
   */
  async getChildren(parentID) {
    const response = await apiClient.get(`api/categoryKeywords/children/${parentID}`);
    return response.data;
  }

  async search(text) {
    const response = await apiClient.get('api/categoryKeywords/search', { params: { text } });
    return response.data;
  }

  /**
   * @returns {Promise<{ categoryID: number, description: string, wordsToInclude: string, wordsToExclude: string,
   *   ancestors: Array<{ categoryID: number, description: string, wordsToInclude: string, wordsToExclude: string }>,
   *   inheritedWordsToInclude: string, inheritedWordsToExclude: string }>}
   */
  async getCategory(categoryID) {
    const response = await apiClient.get(`api/categoryKeywords/${categoryID}`);
    return response.data;
  }

  async saveCategory(categoryID, { wordsToInclude, wordsToExclude }) {
    const response = await apiClient.put(`api/categoryKeywords/${categoryID}`, { wordsToInclude, wordsToExclude });
    apiClient.clearCache('api/categoryKeywords');
    return response.data;
  }

  /**
   * @param {'Self' | 'Leaves'} scope
   * @returns {Promise<{ dryRun: boolean, catCodes: Array<{ categoryID: number, catCodeString: string, catCodeID: number | null }>,
   *   skipped: Array<{ catCodeString: string, reason: string }> }>}
   */
  async addCatCodes(categoryID, scope, { partGroupID, daysBetweenScans }, dryRun = false) {
    const response = await apiClient.post(`api/categoryKeywords/${categoryID}/catCodes`, { partGroupID, daysBetweenScans },
      { params: { scope, dryRun } });
    if (!dryRun) {
      apiClient.clearCache('api/categoryKeywords');
      apiClient.clearCache('api/catCodes');
    }
    return response.data;
  }

  /**
   * @param {'Self' | 'SelfAndDescendants'} scope
   * @returns {Promise<{ dryRun: boolean, catCodes: Array<{ categoryID: number, catCodeString: string, catCodeID: null }>,
   *   skipped: Array<{ catCodeString: string, reason: string }> }>}
   */
  async removeCatCodes(categoryID, scope, dryRun = false) {
    const response = await apiClient.delete(`api/categoryKeywords/${categoryID}/catCodes`, { params: { scope, dryRun } });
    if (!dryRun) {
      apiClient.clearCache('api/categoryKeywords');
      apiClient.clearCache('api/catCodes');
    }
    return response.data;
  }

  async getForCatCode(catCodeString) {
    const response = await apiClient.get(`api/categoryKeywords/forCatCode/${encodeURIComponent(catCodeString)}`);
    return response.data;
  }
}
